import * as React from 'react';
import { SlaDefinition } from './SlaDefinition';
import { WidgetProps } from './WidgetProps';

class CloudwatchWidgetState {
  public uuid = ''
  public comparator: any = ''
  public limit: any = ''
  public metricName: any = ''
  public lbAwsAccont: any = ''
  public lbName: any = ''
  public lbCloudProvider: any = ''
  public lbRegion: any = ''
}

export default class CloudwatchWidget extends React.Component<WidgetProps, CloudwatchWidgetState> {

  constructor(props: any) {
    super(props);
    this.handleComparatorChange      = this.handleComparatorChange.bind(this);
    this.handleLimitChange           = this.handleLimitChange.bind(this);
    this.handleMetricNameChange      = this.handleMetricNameChange.bind(this);
    this.handleLbAwsAccontChange     = this.handleLbAwsAccontChange.bind(this);
    this.handleLbNameChange          = this.handleLbNameChange.bind(this);
    this.handleLbRegionChange        = this.handleLbRegionChange.bind(this);
    this.pushConfigUpdate            = this.pushConfigUpdate.bind(this)

    if (this.props.definition) {
      this.state = {
        uuid: this.props.definition.uuid,
        comparator: this.props.definition.comparator,
        limit: this.props.definition.limit,
        metricName: this.props.definition.metric.name,
        lbAwsAccont: this.props.definition.metric.loadBalancer.account,
        lbName: this.props.definition.metric.loadBalancer.name,
        lbCloudProvider: this.props.definition.metric.loadBalancer.cloudProvider,
        lbRegion: this.props.definition.metric.loadBalancer.region
      }
    }
  }

  public deleteDefn = (e: any) => {
    e.preventDefault();
    this.props.deleteDefinition();
  };

  public pushConfigUpdate() {
    const def = {
      uuid: this.state.uuid,
      limit: +this.state.limit,
      comparator: this.state.comparator,
      metric: {
        type: 'cloudwatch',
        name: this.state.metricName,
        loadBalancer: {
          account: this.state.lbAwsAccont,
          name: this.state.lbName,
          cloudProvider: this.state.lbCloudProvider,
          region: this.state.lbRegion
        }
      }
    } as SlaDefinition
    this.props.updateDefinition(def)
  }

  public handleComparatorChange(e: any) {
    this.setState({comparator: e.target.value}, this.pushConfigUpdate)
  }
  public handleLimitChange(e: any) {
    this.setState({limit: e.target.value}, this.pushConfigUpdate)
  }
  public handleMetricNameChange(e: any) {
    this.setState({metricName: e.target.value}, this.pushConfigUpdate)
  }
  public handleLbAwsAccontChange(e: any) {
    this.setState({lbAwsAccont: e.target.value}, this.pushConfigUpdate)
  }
  public handleLbNameChange(e: any) {
    this.setState({lbName: e.target.value}, this.pushConfigUpdate)
  }
  public handleLbRegionChange(e: any) {
    this.setState({lbRegion: e.target.value}, this.pushConfigUpdate)
  }

  public render() {
    return (
      <div className="panel panel-body rounded">
      <div className="form-group row">
        <div className="col-sm-3 sm-label-right">Metric Name</div>
        <div className="col-sm-9">
          <input
            type="text"
            className="form-control input-sm"
            placeholder="eg: Latency"
            onChange={this.handleMetricNameChange}
            value={this.state.metricName}
          />
        </div>
      </div>
      <div className="form-group row">
        <div className="col-sm-3 sm-label-right">Comparator</div>
        <div className="col-sm-3">
          <select
            className="form-control input-sm"
            onChange={this.handleComparatorChange}
            defaultValue={this.state.comparator}
          >
            <option value="">Select Comparator</option>
            <option value="<">&lt;</option>
            <option value="<=">&lt;=</option>
            <option value="==">==</option>
            <option value=">=">&gt;=</option>
            <option value=">">&gt;</option>
          </select>
        </div>
        <div className="col-sm-3 sm-label-right">Limit</div>
        <div className="col-sm-3">
          <input
            type="text"
            className="form-control input-sm"
            placeholder="eg: 100"
            onChange={this.handleLimitChange}
            value={this.state.limit}
          />
        </div>
      </div>
      <div className="form-group row">
        <div className="col-sm-12 sm-label-left">Loadbalancer Info:</div>
      </div>
      <div className="form-group row">
        <div className="col-sm-3 sm-label-right">AWS account</div>
        <div className="col-sm-3">
          <input
            type="text"
            className="form-control input-sm"
            placeholder="eg: aws-dev"
            onChange={this.handleLbAwsAccontChange}
            value={this.state.lbAwsAccont}
          />
        </div>
        <div className="col-sm-3 sm-label-right">LB name</div>
        <div className="col-sm-3">
          <input
            type="text"
            className="form-control input-sm"
            placeholder="eg: armoryspinnaker-dev-ext"
            onChange={this.handleLbNameChange}
            value={this.state.lbName}
          />
        </div>
      </div>
      <div className="form-group row">
        <div className="col-sm-3 sm-label-right">Cloud Provider</div>
        <div className="col-sm-3">
          <input
            type="text"
            className="form-control input-sm"
            value={this.state.lbCloudProvider}
            disabled={true}
          />
        </div>
        <div className="col-sm-3 sm-label-right">Region</div>
        <div className="col-sm-3">
          <input
            type="text"
            className="form-control input-sm"
            placeholder="eg: us-west-2"
            onChange={this.handleLbRegionChange}
            value={this.state.lbRegion}
          />
        </div>
      </div>
      <DeleteButton deleteFn={this.deleteDefn} numDefs={this.props.numDefs}/>
      </div>
    );
  }
}

function DeleteButton(props: any) {
  let btn  = null;
  if (props.numDefs > 1) {
    btn = (
      <a onClick={props.deleteFn}>
        <span className="glyphicon glyphicon-trash"/>
        Delete SLA definition
      </a>
    )
  } else {
    btn = (
      <div className="alert alert-info">
        INFO: Cannot delete sole SLA definition
      </div>
    )
  }
  return (
    <div className="form-group row col-sm-12 sm-label-left">
      {btn}
    </div>
  )
}
